module.exports = __webpack_public_path__ + "components/page-header/static/mountain-badge--light-e040ae66b36e26ad51dd05608854f6b3.svg";